/* TopLobsta app strip (2026-10-19) */
(function(){
  var el=document.getElementById('tl-app-strip'); if(!el) return;
  var KEY='tl_app_strip_dismissed', DAYS=14;
  try{var t=+localStorage.getItem(KEY); if(t&&Date.now()-t<DAYS*864e5){document.documentElement.classList.add('tlas-hidden');return;} if(t) localStorage.removeItem(KEY);}catch(e){}
  var rm=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(!rm) requestAnimationFrame(function(){el.classList.add('tlas--play');});
  var x=el.querySelector('.tlas__x');
  if(x) x.addEventListener('click',function(e){
    e.preventDefault(); e.stopPropagation();
    try{localStorage.setItem(KEY,String(Date.now()));}catch(err){}
    document.documentElement.classList.add('tlas-hidden');
    var t=document.querySelector('#header a, #header button'); if(t&&t.focus) try{t.focus({preventScroll:true});}catch(err){}
  });
})();
